import { render, staticRenderFns } from "./trainerRegistration.vue?vue&type=template&id=920cd744&scoped=true"
import script from "./trainerRegistration.vue?vue&type=script&lang=js"
export * from "./trainerRegistration.vue?vue&type=script&lang=js"
import style0 from "./trainerRegistration.vue?vue&type=style&index=0&id=920cd744&prod&scoped=true&lang=css"
import style1 from "./trainerRegistration.vue?vue&type=style&index=1&id=920cd744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920cd744",
  null
  
)

export default component.exports